module.exports = __webpack_public_path__ + "img/wheel.6205a5e5.svg";